export default __webpack_public_path__ + "static/media/logo-white.a36f4211.svg";